export var bannerAvatarView = function (url, failedUrl) { return (url && url !== failedUrl ?
    { kind: 'image', url: url } :
    { kind: 'fallback' }); };
